import styled from "styled-components";

const CategoryTitle = styled.div`
  font-weight: bold;
  margin-bottom: 7px;
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 15px;
  border-bottom: 1px solid #cdcdcd;
`;

export default CategoryTitle;
